import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  Row,
  CardBody,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import moment from 'moment';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCopy } from '@fortawesome/free-solid-svg-icons';

const PublishIntegration = ({
  agentId,
  handleAgent,
  updatePreviousVersion,
  currentVersion,
  versionHistory = [],
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(null);
  const [versions, setVersions] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // Helper constto extract and parse Details JSON if present
  useEffect(() => {
    let lst = [];
    versionHistory.forEach((ver) => {
      const obj = JSON.parse(ver);
      lst.push({ date: obj.Date, details: JSON.parse(obj.Details), publishedBy: obj.UserName || obj.publishedBy || "" });
      console.log(lst);
    });

    lst.sort((a, b) => new Date(b.date) - new Date(a.date));
    setVersions(lst);
  }, [versionHistory]);

  const handleShowDetails = (ver) => {
    setSelectedVersion({ ...ver?.details, _date: ver?.date, _publishedBy: ver?.publishedBy || "" });
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedVersion(null);
  };

  const handleAgentVersion = () => {
    updatePreviousVersion(selectedVersion);
    setModalOpen(false);
  }

  const configurationFields = {
    "Conversational Behavior": [
      "welcomemessage",
      "interruptable",
      "keywords",
      "eagerness",
      "spellingpatience",
      "speculativeturn",
      "taketurnaftersilence",
    ],
    "Features, Voices & Languages": [
      "recording",
      "transcribe",
      "voiceactor",
      "agentid",
      "knowledgebaseid",
      "voicesettings"
    ],
    "Security": [
      "dailycalllimit",
      "concurrentcalllimit"
    ]
  };

  console.log('versionHistory', versionHistory);

  let currentDetails = {};
  try {
    currentDetails =
      typeof currentVersion?.Details === "string"
        ? JSON.parse(currentVersion.Details)
        : (currentVersion || {});
  } catch (e) {
    console.error("Invalid currentVersion Details JSON", e);
    currentDetails = {};
  }

  const normalizeObject = (obj = {}) => {
    const newObj = {};
    Object.keys(obj || {}).forEach((key) => {
      newObj[key.toLowerCase()] = {
        value: obj[key],
        originalKey: key
      };
    });
    return newObj;
  };

  const formatKey = (key = '') => {
    return key
      .replace(/([a-z])([A-Z])|([A-Z])([A-Z][a-z])/g, '$1$3 $2$4')
      .replace(/[_-]/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase())
      .trim();
  };

  const formatValue = (val) => {
    if (val === null || val === undefined || val === '') return '-';
    if (Array.isArray(val)) return val.length ? val.join(', ') : '-';
    if (typeof val === 'object') {
      return Object.keys(val).length ? JSON.stringify(val, null, 2) : '-';
    }
    return val.toString();
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Publish your Voice Agent</h6>
          <p>Publish will update or create your voice agent with the latest settings.<br /> Publish after making changes to your integration to ensure your agent is up to date.</p>
        </div>
        <Separator className="mb-3" />
        <Card className="m-4">
          <Colxx xxs="12" className="p-4">
            <Row>
              <Colxx xxs="8">
                {agentId &&
                  <div className="pl-1">
                    <h6>Agent Id</h6>
                    <div className="d-flex mb-3">
                      <p>{agentId}</p>
                      <CopyToClipboard text={agentId}>
                        <Button
                          color="link"
                          outline
                          size="xs"
                          style={{
                            float: 'right',
                            color: 'grey',
                            border: 'none',
                          }}
                          className="ml-2 p-0"
                        >
                          <FontAwesomeIcon icon={faCopy}></FontAwesomeIcon>
                        </Button>
                      </CopyToClipboard>
                    </div>
                  </div>
                }
              </Colxx>
              <Colxx xxs="4" className="d-flex justify-content-end align-items-center">
                <Button color="primary" size="xs" className="mr-2" disabled={isSubmitted} outline onClick={() => { setIsSubmitted(true); handleAgent(); }}>
                  Publish
                </Button>
              </Colxx>
            </Row>
            <h6 className="mb-0 pl-1">Version History</h6>
            <ListGroup className="mt-2">
              {versionHistory.length === 0 ? (
                <ListGroupItem>No version history found.</ListGroupItem>
              ) : (
                versions.map((ver, idx) => (
                  <ListGroupItem
                    key={ver.id || idx}
                    className="d-flex px-3 py-2 justify-content-between align-items-center"
                  >
                    <span>
                      <h6 className="d-flex">Version {versions.length - idx}</h6>
                      <span style={{ color: '#888' }}>
                        {ver.date ? moment(ver.date).format('MMMM D, YYYY h:mma') : ''}
                      </span>
                    </span>
                    <Button
                      color="info"
                      outline
                      size="xs"
                      onClick={() => handleShowDetails(ver)}
                    >
                      View
                    </Button>
                  </ListGroupItem>
                ))
              )}
            </ListGroup>
          </Colxx>
        </Card>
        <Modal isOpen={modalOpen} toggle={closeModal} size="xl">
          <ModalHeader toggle={closeModal} className='px-5 py-4'>Version Details</ModalHeader>
          <ModalBody className="pt-3 ">
            {selectedVersion ? (
              <>
                <Colxx md="12">
                  <span style={{ color: '#888' }}>
                    {selectedVersion?._date && selectedVersion?._publishedBy ? `Published by ${selectedVersion._publishedBy} at ${moment(selectedVersion._date).format('MMMM D, YYYY h:mma')}`
                      : selectedVersion?._date ? `Published at ${moment(selectedVersion._date).format('MMMM D, YYYY h:mma')}` : ''}
                  </span>
                  <table className="table table-bordered mt-2 mb-0">
                    <tbody>
                      <tr>
                        <td style={{ width: "20%" }}><b>Configuration</b></td>
                        <td style={{ width: "40%" }}><b>Previous Version</b></td>
                        <td style={{ width: "40%" }}><b>This Version</b></td>
                      </tr>
                      {[
                        {
                          title: "Conversational Behavior",
                          prev: selectedVersion?.ConfigurationSettings,
                          curr: currentDetails?.configurationSettings
                        },
                        {
                          title: "Features, Voices & Languages",
                          prev: selectedVersion?.Features,
                          curr: currentDetails?.features
                        },
                        {
                          title: "Security",
                          prev: selectedVersion?.Security,
                          curr: currentDetails?.security
                        },

                      ].map((section, idx) => {
                        if (!section.prev && !section.curr) return null;
                        const prevObj = normalizeObject(section.prev);
                        const currObj = normalizeObject(section.curr);
                        return (
                          <Fragment key={idx}>
                            <tr>
                              <td><b>{section.title}</b></td>
                              <td></td>
                              <td></td>
                            </tr>

                            {(configurationFields[section.title] || []).map((key) => {
                              const prevVal = prevObj[key]?.value;
                              const currVal = currObj[key]?.value;
                              const normalize = (v) => v === null || v === undefined ? '' : JSON.stringify(v).toLowerCase();
                              const isSameVal = normalize(prevVal) === normalize(currVal);

                              if (key.toLowerCase() === "voicesettings") {
                                const prevVoice = normalizeObject(prevVal || {});
                                const currVoice = normalizeObject(currVal || {});

                                return Object.keys({
                                  ...prevVoice,
                                  ...currVoice
                                }).map((subKey) => {
                                  const prevSub = prevVoice[subKey]?.value;
                                  const currSub = currVoice[subKey]?.value;
                                  const isSameSub = normalize(prevSub) === normalize(currSub);

                                  return (
                                    <tr key={`${key}-${subKey}`}>

                                      <td>Voice Settings - {formatKey(prevVoice[subKey]?.originalKey || currVoice[subKey]?.originalKey || subKey)}</td>

                                      <td style={{ wordBreak: "break-word" }}>
                                        {formatValue(prevSub)}
                                      </td>

                                      <td style={{ wordBreak: "break-word", backgroundColor: isSameSub ? "transparent" : "#ffe" }}>
                                        {formatValue(currSub)}
                                      </td>
                                    </tr>
                                  );
                                });
                              }

                              return (
                                <tr key={`${idx}-${key}`}>
                                  <td>{formatKey(prevObj[key]?.originalKey || currObj[key]?.originalKey || key)}</td>
                                  <td style={{ wordBreak: "break-word" }}>
                                    {formatValue(prevVal)}
                                  </td>
                                  <td style={{ wordBreak: "break-word", backgroundColor: isSameVal ? "transparent" : "#ffe" }}>
                                    {formatValue(currVal)}
                                  </td>
                                </tr>
                              );
                            })}
                          </Fragment>
                        )
                      })}
                    </tbody>
                  </table>
                </Colxx>
              </>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" className="mx-3" outline size="xs" onClick={closeModal}>
              Close
            </Button>
          </ModalFooter>
        </Modal>
      </CardBody>
    </Card>
  );
};

export default PublishIntegration;
